import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { FilledInput, FormControl, InputAdornment, InputLabel, } from '@mui/material';
import { MultiLangAdornment } from './multiLangAdornment';
export const MultiLangInput = ({ value = null, sx, label, onChange, onBlur, fullWidth }) => {
    const [internalValue, setInternalValue] = useState(value || { de: '', en: '' });
    const [currentLang, setCurrentLang] = useState('de');
    useEffect(() => {
        if (value) {
            setInternalValue(value);
        }
    }, [value]);
    return (_jsxs(FormControl, { sx: { ...sx }, variant: 'filled', fullWidth: fullWidth, children: [_jsx(InputLabel, { htmlFor: 'outlined-adornment-password', children: label }), _jsx(FilledInput, { sx: {
                    pr: 0,
                }, type: 'text', value: internalValue[currentLang], onChange: (e) => {
                    const { value } = e.target;
                    const nextValue = {
                        ...{ de: '', en: '' },
                        ...internalValue,
                        [currentLang]: value,
                    };
                    setInternalValue(nextValue);
                    if (onChange)
                        onChange(nextValue);
                }, onBlur: () => {
                    if (onBlur)
                        onBlur(internalValue);
                }, endAdornment: _jsx(InputAdornment, { sx: {
                        height: 'auto',
                        maxHeight: 'unset',
                    }, position: 'end', children: _jsx(MultiLangAdornment, { currentLang: currentLang, onChangeLang: (nextLang) => setCurrentLang(nextLang) }) }) })] }));
};
